<template>
  <div>
    <b-list-group>
      <b-list-group-item class="flex-column align-items-start">
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <i class="fa fa-2x mr-2" :class="findIconClass(taskDetails.taskTypeId)"></i>
            <h5>{{taskDetails.taskPriorityName}} - {{taskDetails.subject}}</h5>
          </div>
          <div class="d-flex">
            <b-link><i class="fa fa-pencil fa-2x mr-2" title="Edit" @click="$emit('openTodoModal')"/></b-link>
            <b-link><i class="fa fa-thumbs-o-up fa-2x mr-2" title="Close" v-b-modal.close-task-modal/></b-link>
            <b-link><i class="fa fa-comment fa-2x" title="New note" v-b-modal.add-task-note/></b-link>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-between mt-1">
          <div>
            <div class="h6 m-0">Contact / Company</div>
            <div>
              <b-link @click="onNavigate(`/company/${taskDetails.companyId}/contacts/${taskDetails.contactId}`)">
                {{taskDetails.contactFirstName}} {{taskDetails.contactLastName}}
              </b-link>
              /
              <b-link @click="onNavigate(`/company/${taskDetails.companyId}/details`)">
                {{taskDetails.companyName}}
              </b-link>
            </div>
          </div>
          <h6>{{taskDetails.accountType}}</h6>
        </div>
        <div class="d-flex w-100 mt-1">
          <div class="mr-3">
            <div class="h6 m-0">Assigned</div>
            <div>{{taskDetails.assignedToUserFullName}}</div>
          </div>
          <div class="mr-3">
            <div class="h6 m-0">Due</div>
            <div>{{taskDetails.taskDueDateString}} {{taskDetails.taskDueHour}}:{{taskDetails.taskDueMinute}}
              {{taskDetails.taskDueAmPm}}
            </div>
          </div>
          <div class="mr-3">
            <div class="h6 m-0">Aging</div>
            <div>{{taskDetails.aging}} days</div>
          </div>
        </div>
        <hr/>
        <div class="d-flex w-100 justify-content-between">
          <div>
            <div class="h6 m-0">Cell</div>
            <b-link :href="`tel:${taskDetails.cellPhone}`">{{taskDetails.cellPhone}}</b-link>
          </div>
          <div>
            <div class="h6 m-0">Direct</div>
            <b-link :href="`tel:${taskDetails.directPhone}`">{{taskDetails.directPhone}}</b-link>
          </div>
          <div>
            <div class="h6 m-0">Main</div>
            <b-link :href="`tel:${taskDetails.mainPhone}`">{{taskDetails.mainPhone}}</b-link>
          </div>
          <div>
            <div class="h6 m-0">Email</div>
            <b-link @click="sendEmail">{{taskDetails.contactEmail}}</b-link>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-between">
          <div>
            <div class="h6 m-0">Company Address</div>
            <b-textarea :value="taskDetails.fullAddress" disabled :rows="(taskDetails.fullAddress)?taskDetails.fullAddress.split(/\r*\n/).length:7" cols="60"/>
          </div>
        </div>
        <div class="mt-1">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn block href="#" v-b-toggle.accordion1>Description</b-btn>
            </b-card-header>
            <b-collapse id="accordion1" visible accordion="desc-accordion" role="tabpanel">
              <b-card-body>
                <p class="card-text">
                  {{taskDetails.description}}
                </p>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-btn block href="#" v-b-toggle.accordion2>Notes</b-btn>
            </b-card-header>
            <b-collapse id="accordion2" visible accordion="note-accordion" role="tabpanel">
              <b-table :bordered="false" :small="true" responsive="sm" :items="taskNotes" :fields="captions" style="table-layout: fixed">
                <template #cell(noteDetail)="data">
                  <span style="white-space: normal !important; word-wrap: break-word; min-width: 160px;max-width: 160px;">
                    {{ data.item.noteDetail }} 
                  </span>
                </template>
              </b-table>
            </b-collapse>
          </b-card>
        </div>
      </b-list-group-item>
    </b-list-group>
    <b-modal
      id="add-task-note"
      size="sm"
      title="Add note"
      ok-title="Save"
      :ok-disabled="!newNote.length"
      @shown="resetNote"
      @ok="handleAddNote"
      no-close-on-backdrop
    >
      <b-form-group label="Note">
        <b-textarea v-model.trim="newNote"></b-textarea>
      </b-form-group>
    </b-modal>
    <send-emails :sendEmailData="sendEmailData"></send-emails>
  </div>
</template>

<script>
  import { date } from '@/shared/filters';
  import { TODO_TASK_TYPES } from '@/shared/constants';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import SendEmails from '@/shared/components/SendEmails/index';
  import contactService from '@/resources/ContactService';

  export default {
    name: 'TaskDetail',
    props: {
      taskDetails: {
        type: Object,
        default: () => {
        },
      },
      assignedUsers: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      SendEmails,
    },
    data: () => ({
      captions: [
        { key: 'noteDate', label: 'Date' },
        { key: 'addedBy' },
        { key: 'noteDetail', label: 'Note' },
      ],
      date,
      taskTypes: TODO_TASK_TYPES,
      newNote: '',
      sendEmailData: {},
    }),
    computed: {
      ...mapGetters('account', ['userId']),
      taskNotes() {
        if (this.taskDetails && this.taskDetails.notes) {
          let taskNotes = JSON.parse(this.taskDetails.notes);
          if (taskNotes == undefined || taskNotes.length === 0) return [];
          return taskNotes.map((note) => ({
            ...note,
            noteDate: this.date(note.noteDate),
            addedBy: this.findUserName(note.addedBy),
          }));
        }
        return [];
      },
    },
    methods: {
      ...mapActions('todotasks', ['manageTask']),
      findIconClass(taskTypeId) {
        if (taskTypeId) {
          const myData = _.find(this.taskTypes, {id: taskTypeId});
          if (typeof myData !== 'undefined') {
            return myData.icon;
          }
        }
      },
      findUserName(userId) {
        if (userId) {
          const myData = _.find(this.assignedUsers, {id: userId});
          if (typeof myData !== 'undefined') {
            return myData.fullName;
          }
        }
      },
      async handleAddNote() {
        if (this.newNote !== '') {
          let existingNotes = (this.taskDetails.notes) ? JSON.parse(this.taskDetails.notes) : [];
          existingNotes.push({ noteDate: new Date(), addedBy: this.userId, noteDetail: this.newNote });
          await this.manageTask({ ...this.taskDetails, notes: JSON.stringify(existingNotes) });

          if (this.taskDetails.contactId) {
            const note = `TASK NOTE: ${this.newNote}`;
            contactService.createNote(this.taskDetails.contactId, note);
          }

          this.$emit('refreshGrid');
        }
      },
      async sendEmail() {
        this.sendEmailData = {
          source: 'ToDo Task',
          to: this.taskDetails.contactEmail,
        };
        this.$root.$emit('bv::show::modal', 'send-email-modal');
      },
      resetNote() {
        this.newNote = '';
      },
      onNavigate(path) {
        this.$router.push({
          path: path,
          query: { listPage: 'todotasks' }
        });
      },
    },
  };
</script>
